// extracted by mini-css-extract-plugin
export var typingIndicator = "_pg-0";